/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiScreeningManualSearch,
    InternalApiScreeningManualSearchFromJSON,
    InternalApiScreeningManualSearchToJSON,
    InternalApiScreeningManualSearchHit,
    InternalApiScreeningManualSearchHitFromJSON,
    InternalApiScreeningManualSearchHitToJSON,
} from '../models';

export interface SearchInternalRequest {
    internalApiScreeningManualSearch: InternalApiScreeningManualSearch;
}

/**
 * 
 */
export class ScreeningSearchInternalApi extends runtime.BaseAPI {

    /**
     */
    async searchInternalRaw(requestParameters: SearchInternalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningManualSearchHit>>> {
        if (requestParameters.internalApiScreeningManualSearch === null || requestParameters.internalApiScreeningManualSearch === undefined) {
            throw new runtime.RequiredError('internalApiScreeningManualSearch','Required parameter requestParameters.internalApiScreeningManualSearch was null or undefined when calling searchInternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/screening/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningManualSearchToJSON(requestParameters.internalApiScreeningManualSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningManualSearchHitFromJSON));
    }

    /**
     */
    async searchInternal(requestParameters: SearchInternalRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningManualSearchHit>> {
        const response = await this.searchInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
